export default __webpack_public_path__ + "static/media/carro.eb19d00a.jpg";